import React from "react";
import "./MasterLayout.scss";

interface MasterLayoutProps {
  header: React.ReactNode;
  sidebar?: React.ReactNode;
  footer?: React.ReactNode;
  body: React.ReactNode;
  className?: string;
}

const MasterLayout: React.FC<MasterLayoutProps> = ({ header, sidebar, footer, body, className }: MasterLayoutProps) => {
  return (
    <div className={`master-layout ${className}`}>
      {header}
      <div className="master-layout__container">
        {sidebar && sidebar}
        <div className="master-layout__body">
          {body}
          {footer && footer}
        </div>
      </div>
    </div>
  );
};

export default MasterLayout;
